<template>
  <div ref="primaryMenuWrapper" class="secondary-header--uniform secondary-soco-review">
    <div class="container">
      <div class="box-secondary">
        <ul v-if="screen.isDesktop" class="primary-menu hidden-xs hidden-sm">
          <li
            class="primary-menu__li primary-dropdown primary-dropdown--togglecategories"
            @mouseover="setActiveHeaderMenu"
            @mouseleave="onMouseLeave"
          >
            <a href="javascript:"><span>Categories</span></a>
            <div class="primary-dropdown-menu primary-dropdown-menu--categories">
              <DropdownCategory />
            </div>
          </li>
          <li
            class="primary-menu__li primary-dropdown primary-dropdown--togglebrands"
            @mouseover="setActiveHeaderMenu"
            @mouseleave="onMouseLeave"
          >
            <a href="javascript:"><span>Brands</span></a>
            <div class="primary-dropdown-menu primary-dropdown-menu--brands">
              <Brands></Brands>
            </div>
          </li>
          <li class="primary-menu__li primary-dropdown" @mouseleave="onMouseLeave">
            <a href="" @click.prevent="productMatch">
              <span>Expert Review</span>
            </a>
          </li>
        </ul>

        <div v-else id="primaryMenuMobileWrapper" class="hidden-lg hidden-md">
          <div class="primary-menu-mobile">
            <div class="primary-menu-mobile__item" :class="{ active: primaryMenuMobileActive === 'department' }">
              <a href="" class="primary-menu-mobile__toggle" @click.prevent="selectPrimaryMenuMobile('department')"
                >Categories</a
              >
            </div>
            <div class="primary-menu-mobile__item" :class="{ active: primaryMenuMobileActive === 'brand' }">
              <a href="" class="primary-menu-mobile__toggle" @click.prevent="selectBrowseByBrand('brand')">Brands</a>
            </div>
          </div>
          <div class="primary-menu-mobile__content">
            <div v-show="primaryMenuMobileActive === 'department'">
              <ul class="list-departments">
                <template v-for="(grandParent, key) in categoriesOfDepartment">
                  <ItemGrandParent
                    v-if="grandParent"
                    :key="`itemGrandParent${key}`"
                    :grand-parent="grandParent"
                    :key-grand-parent="key"
                    @selected="setSelected(key)"
                  />
                </template>
              </ul>
              <template v-if="loading">
                <ul id="listParentMobile" class="list-category-department element-placeholder selected">
                  <li v-for="(n, i) in 3" :key="i">
                    <a href="" class="placeholder" style="width: 80px"></a>
                  </li>
                </ul>
              </template>
              <template v-else>
                <ul
                  v-if="activeIndexGrandParent >= 0"
                  id="listParentMobile"
                  class="list-category-department"
                  :class="{ selected: $SO.size(parentActive) }"
                >
                  <li ref="listAllParent">
                    <router-link
                      :to="`/category/${categoriesOfDepartment[activeIndexGrandParent].my_soco_sql_id}/${grandParentSlug}`"
                      @click.native="selectParent"
                      >All {{ categoriesOfDepartment[activeIndexGrandParent].name | ucwords }}</router-link
                    >
                  </li>
                  <ItemParent
                    v-for="(parent, key) in parentActive"
                    :key="`itemParent${key}`"
                    :parent="parent"
                    :grand-parent="categoriesOfDepartment[activeIndexGrandParent].children"
                    :key-parent="key"
                  />
                </ul>
                <ul
                  v-if="activeIndexParent >= 0 && activeIndexGrandParent >= 0"
                  class="list-subcategory-department"
                  :class="{ selected: $SO.size(childActive) }"
                >
                  <ItemChild
                    v-for="(child, key) in childActive"
                    :key="`itemChild${key}`"
                    :parent="parentActive[activeIndexParent]"
                    :grand-parent="categoriesOfDepartment[activeIndexGrandParent]"
                    :child="child"
                    :key-child="key"
                  />
                </ul>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ClickOutside from 'vue-click-outside';
// import Brands from '@/components/global/navbar/brands/brands';
// import DropdownCategory from './dropdown-category';
// import ItemGrandParent from './item-grand-parent';
// import ItemParent from './item-parent';
// import ItemChild from './item-child';

export default {
  name: 'header-primary-menu',
  components: {
    Brands: () => import('@/components/global/navbar/brands/brands'),
    DropdownCategory: () => import('./dropdown-category'),
    ItemGrandParent: () => import('./item-grand-parent'),
    ItemParent: () => import('./item-parent'),
    ItemChild: () => import('./item-child'),
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    screen() {
      return this.$store.state.screen;
    },
    activeHeaderMenu() {
      return this.$store.state.activeHeaderMenu;
    },
    activeIndexChild() {
      return this.$store.state.header.mobile.activeIndexChild;
    },
    activeIndexGrandParent() {
      return this.$store.state.header.mobile.activeIndexGrandParent;
    },
    activeIndexParent() {
      return this.$store.state.header.mobile.activeIndexParent;
    },
    brands() {
      return this.$store.state.brands;
    },
    categoriesOfDepartment() {
      return this.$store.state.header.categoriesOfDepartment;
    },
    childActive() {
      if (this.activeIndexGrandParent >= 0 && this.activeIndexParent >= 0) {
        return this.parentActive[this.activeIndexParent].children;
      } else {
        return {};
      }
    },
    grandParentSlug() {
      if (this.activeIndexGrandParent >= 0) {
        return this.$options.filters.slug(this.categoriesOfDepartment[this.activeIndexGrandParent].name);
      } else {
        return 'default';
      }
    },
    parentActive() {
      if (this.activeIndexGrandParent >= 0) {
        return this.categoriesOfDepartment[this.activeIndexGrandParent].children;
      } else {
        return {};
      }
    },
    popularMakeup() {
      return this.$store.state.popularMakeup;
    },
    primaryMenuMobileActive() {
      return this.$store.state.header.primaryMenuMobileActive;
    },
    isLogin() {
      return this.$SO.size(this.$store.state.auth.userProfile);
    },
    user() {
      return this.$store.state.auth.userProfile;
    },
    showOverlay() {
      return this.$store.state.$_Header.showOverlay;
    },
    // isBrowseByBrand() {
    //   return this.$store.state.filterProduct.browseBy.brand;
    // }
  },
  watch: {
    primaryMenuMobileActive() {
      if (!this.$store.state.screen.isDesktop) {
        if (this.primaryMenuMobileActive) {
          const overlayElement = document.createElement('div');
          const bodyElement = document.querySelector('body');
          overlayElement.setAttribute('id', 'overlayStyle');

          if (Boolean(document.getElementById('overlayStyle')) === false) {
            bodyElement.appendChild(overlayElement);
            this.$SO('body').addClass('no-scroll');
          }
        } else {
          const overlayElement = document.getElementById('overlayStyle');
          overlayElement.remove();
          this.$SO('body').removeClass('no-scroll');
          this.$store.commit('updateActiveIndexGrandParent', -1);
          this.$store.commit('updateActiveIndexParent', -1);
          this.$store.commit('updateActiveIndexChild', -1);
        }
      }
    },
    showOverlay: {
      handler(newVal) {
        if (newVal == true) {
          const overlayElement = document.createElement('div');
          const bodyElement = document.querySelector('body');
          overlayElement.setAttribute('id', 'overlayStyle');

          if (Boolean(document.getElementById('overlayStyle')) === false) {
            bodyElement.appendChild(overlayElement);
            this.$SO('body').addClass('no-scroll');
          }
        } else {
          const overlayElement = document.getElementById('overlayStyle');
          if (overlayElement) {
            overlayElement.remove();
          }
          this.$SO('body').removeClass('no-scroll');
          this.$store.commit('updateActiveIndexGrandParent', -1);
          this.$store.commit('updateActiveIndexParent', -1);
          this.$store.commit('updateActiveIndexChild', -1);
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.screen.isDesktop) {
      window.addEventListener('scroll', this.handleScroll, {
        capture: true,
        passive: true,
        behavior: 'smooth',
      });
    }
    document.addEventListener('click', this.documentClick);
  },
  destroyed() {
    document.removeEventListener('click', this.documentClick);
    const overlayElement = document.getElementById('overlayStyle');
    if (overlayElement) {
      overlayElement.remove();
    }
    this.$SO('body').removeClass('no-scroll');
    this.$store.commit('updateActiveIndexGrandParent', -1);
    this.$store.commit('updateActiveIndexParent', -1);
    this.$store.commit('updateActiveIndexChild', -1);
  },
  methods: {
    ...mapActions('$_Header', ['setOverlay']),
    documentClick(e) {
      const target = e.target;

      if (this.primaryMenuMobileActive) {
        if (this.$SO(target).closest('#primaryMenuMobileWrapper').length < 1) {
          this.$store.commit('updatePrimaryMenuMobile', '');
        }
      }
    },
    setActiveHeaderMenu(e) {
      this.setOverlay(true);
    },
    onMouseLeave(e) {
      this.setOverlay(false);
    },
    handleScroll(event) {
      const el = this.$refs.primaryMenuWrapper;

      if (el) {
        const scrollY = window.pageYOffset || document.documentElement.scrollTop;
        const header = el;

        if (this.screen.isDesktop) {
          header.classList.add('start-scroll');
          if (header && scrollY <= this.lastScroll) {
            header.classList.add('sticky');
          } else {
            header.classList.remove('sticky');
          }

          if (scrollY < 100) {
            header.classList.remove('sticky');
          }

          if (scrollY === 0) {
            header.classList.add('sticky');
          }
        }

        this.lastScroll = scrollY;
      }
    },
    selectParent(e) {
      this.$store.commit('updateActiveIndexParent', -1);
      this.$store.commit('updateActiveIndexChild', -1);
      this.$store.commit('updatePrimaryMenuMobile', '');
    },
    selectBrowseByBrand(type) {
      this.$store.commit('setBrowseBy', { type: 'brand', value: true });
    },
    selectPrimaryMenuMobile(menuFlag) {
      const newValue = menuFlag === this.primaryMenuMobileActive ? '' : menuFlag;
      this.$store.commit('updatePrimaryMenuMobile', newValue);
    },
    setSelected(data) {
      this.$store.commit('updateActiveIndexGrandParent', data);
      // if (!this.categoriesOfDepartment[data.indexArray].children) {
      // this.loading = true;
      // this.$store
      //   .dispatch('getChildrenOfDepartments', {
      //     categoryId: data._id,
      //     categoriesOfDepartmentKey: data.indexArray,
      //   })
      //   .then((res) => {
      //     this.loading = false;
      //   })
      //   .catch((err) => {
      //     this.loading = false;
      //   });
      // }
    },
    productMatch() {
      if (this.isLogin) {
        if (Boolean(this.user.beauty && this.user.beauty.length)) {
          this.$router.push('/expert');
        } else {
          this.$store.commit('toggleModalGlobalState', {
            modalName: 'confirmBP',
          });
        }
      } else {
        this.$router.push('/expert');
      }
    },
  },
};
</script>
